import { useTranslation } from "react-i18next";

import "../styles.css";

const MissingValue = () => {
  const { t } = useTranslation();

  return (
    <>
      <span aria-hidden>—</span>

      <span className="participants-visually-hidden">
        {t("certification.admin.stats.notAvailable")}
      </span>
    </>
  );
};

export default MissingValue;
